import React from 'react';
export default function Spacer(props) {
    var _a, _b;
    const elData = JSON.stringify({ props }, undefined, 2);
    return (React.createElement("div", { className: "elementor-spacer" },
        React.createElement("div", { style: { 'height': `${(_a = props === null || props === void 0 ? void 0 : props.space) === null || _a === void 0 ? void 0 : _a.size}${(_b = props === null || props === void 0 ? void 0 : props.space) === null || _b === void 0 ? void 0 : _b.unit}` } })));
}
